"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWorkingAtFortum = function IconWorkingAtFortum(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14.293 9.593 19.5 4.386l18.282 18.282 6.637 6.547-12.712 12.712a4.2 4.2 0 0 1-1.499.96 4.4 4.4 0 0 1-1.71.272 4.7 4.7 0 0 1-1.713-.4 5 5 0 0 1-1.308-.87l-.184-.182L3.786 20.2l5.207-5.207 1.414 1.414L6.615 20.2l20.106 20.107c.255.265.559.48.88.627.31.136.643.213.979.227.317.012.634-.038.934-.15q.353-.13.641-.372l.138-.126L41.58 29.224l-5.207-5.137L19.5 7.215l-3.793 3.792zm21.123 19.273.708.707-7.21 7.21-.708-.707zm-1.092-1.093-.707-.707-7.21 7.21.707.707zM19.197 12.656l.707.707-7.2 7.2-.708-.707zm-4.34 1.447-7.21-7.21-1.414 1.414 7.21 7.21zM26.83 23.48l1.87.5a5.275 5.275 0 0 1-10.19-2.73l1.19-.68.68 1.18a3.34 3.34 0 1 0 6.45 1.73m-.791.984a3 3 0 1 1-4.704-3.724 3 3 0 0 1 4.704 3.724",
    clipRule: "evenodd"
  })));
};

export { IconWorkingAtFortum, IconWorkingAtFortum as default };
